// Services in this file are for passing user and contact information
// back to the admin portion of the application

import { HttpService, getError } from './http.service';

const ContactService = {
  ADMIN_API_HOST: process.env.VUE_APP_ADMIN_HOST,

  requestPricing(requestData) {
    return HttpService.httpPost(`${this.ADMIN_API_HOST}/api/pricing`, requestData)
      .catch(e => {
        throw getError(e);
      });
  },

  contactUs(requestData) {
    return HttpService.httpPost(`${this.ADMIN_API_HOST}/api/contact-us`, requestData)
      .catch(e => {
        throw getError(e);
      });
  },
};

export default ContactService;
